import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import HttpClientXml from "../utils/HttpClientXml";
import HomeService from "../Services/HomeService";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function AddHighlightedProject() {
  const [title, setTitle] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [price, setPrice] = useState("");
  const [image, setImage] = useState(null);
  const [type, setType] = useState("");
  const [locationText, setLocationText] = useState("");
  const [locationUrl, setLocationUrl] = useState("");
  const [propertyUrl, setPropertyUrl] = useState("");
  const navigate = useNavigate();

  const handleImageUpload = async (e) => {
    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setImage(res.image);
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!title.trim()) {
      toast.error("Project title is required!");
      return;
    }
    if (!shortDescription.trim()) {
      toast.error("Short description is required!");
      return;
    }
    if (!price.trim()) {
      toast.error("Price is required!");
      return;
    }
    if (!image) {
      toast.error("Project image is required!");
      return;
    }

    const data = {
      title: title,
      shortDescription: shortDescription,
      price: price,
      image: image,
      type: type,
      locationText: locationText,
      locationUrl: locationUrl,
      propertyUrl: propertyUrl,
    };

    try {
      const res = await HomeService?.createHighlightedProject(data);
      if (res?.status) {
        toast.success("Highlighted project added successfully!");
        clearAddForm();
        navigate("/manage-highlighted-project");
      } else {
        toast.error(res?.message || "Failed to add highlighted project.");
      }
    } catch (error) {
      toast.error("Failed to add highlighted project.");
      console.error("Error adding highlighted project:", error);
    }
  };

  const clearAddForm = () => {
    setTitle("");
    setShortDescription("");
    setPrice("");
    setImage(null);
    setType("");
    setLocationText("");
    setLocationUrl("");
    setPropertyUrl("");
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Add Highlighted Project
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <label htmlFor="title">
                    Project Title <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="title"
                    className="form-control"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Enter project title"
                    required
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="shortDescription">
                    Short Description <span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="shortDescription"
                    className="form-control"
                    value={shortDescription}
                    onChange={(e) => setShortDescription(e.target.value)}
                    placeholder="Enter short description"
                    rows="3"
                    required
                  ></textarea>
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="price">
                    Price <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="price"
                    className="form-control"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    placeholder="Enter price (e.g., 50 LKH)"
                    required
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="projectImage">
                    Upload Project Image <span className="text-danger">*</span>
                  </label>
                  {image && (
                    <img
                      src={image}
                      alt="Project Preview"
                      style={{
                        display: "block",
                        margin: "10px 0",
                        maxHeight: "100px",
                      }}
                    />
                  )}
                  <input
                    type="file"
                    id="projectImage"
                    className="form-control"
                    onChange={handleImageUpload}
                    accept="image/*"
                    required
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="type">
                    Type
                  </label>
                  <input
                    type="text"
                    id="type"
                    className="form-control"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    placeholder="Enter project type (e.g. Apartment, Villa)"
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="locationText">
                    Location Text
                  </label>
                  <input
                    type="text"
                    id="locationText"
                    className="form-control"
                    value={locationText}
                    onChange={(e) => setLocationText(e.target.value)}
                    placeholder="Enter location text"
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="locationUrl">
                    Location URL
                  </label>
                  <input
                    type="text"
                    id="locationUrl"
                    className="form-control"
                    value={locationUrl}
                    onChange={(e) => setLocationUrl(e.target.value)}
                    placeholder="Enter location URL"
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="propertyUrl">
                    Property URL
                  </label>
                  <input
                    type="text"
                    id="propertyUrl"
                    className="form-control"
                    value={propertyUrl}
                    onChange={(e) => setPropertyUrl(e.target.value)}
                    placeholder="Enter property URL"
                  />
                </div>
              </div>
              <button
                type="submit"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                }}
              >
                Add Highlighted Project
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddHighlightedProject;
